import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Container } from 'components/ui/Container';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { accessibilityParamsStore } from 'stores/root';

import AccessibilityMenu from './AccessibilityMenu';
import Footer from './Footer';
import Header from './Header';
import MobileBackButton from './MobileBackButton';

import s from './Layout.module.scss';

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isMobileApp = useIsMobileApp();
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <div className={cn(s.layout, isMobileApp && s['layout_mobile-app'], isAccessibilityMode && s.layout_accessibility)}>
      {!isMobileApp && <Header />}
      {isMobileApp && (
        <div className={s['layout__mobile-app-bar']}>
          <MobileBackButton />
        </div>
      )}
      <Container element="main" className={s.layout__main}>
        {children}
      </Container>
      {!isMobileApp && <Footer className={s.layout__footer} />}
      {accessibilityParamsStore.isOpen && <AccessibilityMenu />}
    </div>
  );
};

export default observer(Layout);
